import { type FC } from "react";
import { Salaries, type SalariesProps } from "@legacy_user_frontend/components/ui_parts/salaries";
import { Shop } from "./src/Shop";
import { ShopAccordion, type ShopAccordionProps } from "./src/ShopAccordion";
import * as styles from "./styles.css";

type RequirementsProps = {
  requirements: {
    clientShops: {
      totalNumber: ShopAccordionProps["totalNumber"];
      shopInformations: ShopAccordionProps["shopInformations"] | [];
    };
    salaries: SalariesProps["salaries"] | [];
  };
  clientShopsEvent: {
    clientShopsGaAction: ShopAccordionProps["gaAction"];
    clientShopsGaLabels: ShopAccordionProps["gaLabels"];
  };
  isSp: boolean;
  query: string;
  className?: string;
};

export const SalaryAndShopRequirements: FC<RequirementsProps> = ({
  requirements: {
    salaries,
    clientShops: { totalNumber, shopInformations },
  },
  clientShopsEvent: { clientShopsGaAction, clientShopsGaLabels },
  isSp,
  query,
  className,
}) => (
  <div className={`${styles.wrapper} ${className ?? ""}`}>
    <dl className={styles.table}>
      <dt className={`${styles.tableDt} ${styles.tableDtDdFlex}`}>
        <span>
          <i className="icon-yen" />
          <span className={styles.tableTitle}>給与</span>
        </span>
      </dt>
      <dd className={`${styles.tableDd} ${styles.tableDtDdFlex}`}>
        {salaries && salaries.length > 0 && <Salaries salaries={salaries} />}
      </dd>
      <dt className={`${styles.tableDt} ${styles.tableDtDdFlex} ${styles.tableDtNotFirst}`}>
        <span>
          <i className="icon-location" />
          <span className={styles.tableTitle}>店舗</span>
        </span>
      </dt>
      <dd
        className={`${styles.tableDd} ${styles.tableDtDdFlex} ${styles.tableDdNotFirst} js-link-expand__unlink`}
      >
        {totalNumber > 1 && (
          <p className={styles.shopNumOuter}>
            <span className={styles.shopNum}>{totalNumber}</span>
            店舗で募集中
          </p>
        )}
        {((isSp && totalNumber > 1) || (!isSp && totalNumber > 3)) &&
          shopInformations.length > 0 && (
            <ShopAccordion
              totalNumber={totalNumber}
              shopInformations={shopInformations}
              gaAction={clientShopsGaAction}
              gaLabels={clientShopsGaLabels}
              isSp={isSp}
              query={query}
            />
          )}
        {((isSp && totalNumber <= 1) || (!isSp && totalNumber <= 3)) &&
          shopInformations.length > 0 && (
            <Shop
              totalNumber={totalNumber}
              shopInformations={shopInformations}
              gaAction={clientShopsGaAction}
              gaLabels={clientShopsGaLabels}
              isSp={isSp}
              query={query}
            />
          )}
      </dd>
    </dl>
  </div>
);
